import { actionTypes } from "../actions/types";

const ResultsReducer = (state = [], action) => {
  switch (action.type) {
    case actionTypes.FETCH_RESULTS:
      return { ...state, results: action.payload };
    case actionTypes.CLEAR_RESULTS:
      return { ...state, results: undefined };
    default:
      return state;
  }
};

export default ResultsReducer;
